import Config from "../Create/Config";

const inputsWhiteList = ["cyclename", "startdate"];

export default {
	pageName: "ReviewCycleEdit",

	// import data from the create Config file
	blipHeight: 40,
	confirmationDateFormat: "MMM D, YYYY h:mm a",
	formWidth: 440,
	formHorizontalMargin: 40,
	formVerticalMargin: 40,
	formBorderSize: 1,
	formControlsHeight: 60,
	maxFormsCount: 50,
	inputs: Config.inputs.filter((item) => inputsWhiteList.indexOf(item.key) >= 0),

	bulkUpdateInputAttributes: {
		authorsDueDate: {
			label: "authors due date",
			type: "date",
		},
		signersDueDate: {
			label: "signers due date",
			type: "date",
		},
		visible: {
			label: "visible to the subject",
			type: "bool",
		},
		redacted: {
			label: "redact authors",
			type: "bool",
		},
	},
};
